import { UAParser } from "ua-parser-js";

import { type ClientOs } from "@btnet/utilities-analytics";

export function getClientOs(): ClientOs {
    // Possible 'os.name's: https://github.com/faisalman/ua-parser-js/tree/1.0.38#documentation
    const name = UAParser(navigator.userAgent).os.name;
    switch (name) {
        case "Windows":
            return "windows";
        case "Mac OS":
            return "macos";
        case "Linux":
            return "linux";
        case "Android":
            return "android";
        case "iOS":
            return "ios";
        default:
            return "other";
    }
}
